import { LabourItemDetailsPanel } from '../../../sites/components/panel/organisms/LabourItemDetailsPanel';

interface LabourItemDrawerContentProps {
  labourItemId: number;
}

export function LabourItemDrawerContent({
  labourItemId,
}: LabourItemDrawerContentProps) {
  return <LabourItemDetailsPanel labourItemId={labourItemId} />;
}
